var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"d-flex w-100",staticStyle:{"height":"100vh"},attrs:{"element-loading-text":"系統初始化中..."}}):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }